import Layout from "@/components/feature/Layout";
import PageHero from "@/components/base/PageHero";
import SectionHeader from "@/components/base/SectionHeader";
import CTAPanel from "@/components/base/CTAPanel";

const serviceAreas = [
  {
    title: "AI-Assisted Application Engineering",
    description: "AI-assisted approaches applied to enterprise application development, modernization, and maintenance programs.",
    icon: "ri-robot-line",
  },
  {
    title: "Data Preparation & Pipelines",
    description: "Engineering support for data preparation, cleansing, and pipeline design that enables analytics and intelligence initiatives.",
    icon: "ri-database-2-line",
  },
  {
    title: "Business Intelligence & Analytics",
    description: "Reporting, dashboarding, and analytics support that helps organizations derive practical insight from enterprise data.",
    icon: "ri-bar-chart-line",
  },
  {
    title: "Intelligent Workflow Automation",
    description: "Automation of routine business processes using enterprise platforms, including Microsoft Power Platform workflow capabilities.",
    icon: "ri-flow-chart",
  },
  {
    title: "Machine Learning Integration",
    description: "Integration of machine learning models and services into existing enterprise applications and data environments.",
    icon: "ri-ai-generate",
  },
  {
    title: "AI Governance & Readiness",
    description: "Practical support for AI adoption, including data quality, documentation, and responsible-use considerations.",
    icon: "ri-shield-check-line",
  },
  {
    title: "Document & Content Processing",
    description: "Automated extraction and processing of structured and unstructured content to support business workflows.",
    icon: "ri-file-text-line",
  },
  {
    title: "Requirements & Adoption Support",
    description: "Assistance with AI use-case identification, requirements, and user enablement for enterprise deployments.",
    icon: "ri-lightbulb-line",
  },
];

export default function AIEngineering() {
  return (
    <Layout>
      <PageHero
        title="AI & Intelligent Engineering"
        subtitle="Application & Data Engineering"
        description="AI-assisted application engineering, data pipelines, analytics, workflow automation, and machine learning integration for enterprise and government programs."
        size="md"
      />

      <section className="section-padding bg-white">
        <div className="container-page">
          <SectionHeader
            title="Service Areas"
            description="AI and intelligent engineering capabilities delivered as part of broader enterprise technology engagements."
          />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {serviceAreas.map((area) => (
              <div key={area.title} className="card-base p-6">
                <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center mb-4">
                  <i className={`${area.icon} text-primary-600`}></i>
                </div>
                <h3 className="text-lg font-bold text-foreground-900 mb-2">
                  {area.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {area.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTAPanel
        title="Exploring AI or Analytics Support?"
        description="Mitaja provides AI-assisted and data engineering services as part of broader enterprise technology engagements."
        primaryAction={{ label: "Contact Us", href: "/contact" }}
        secondaryAction={{ label: "View All Capabilities", href: "/capabilities" }}
        variant="dark"
      />
    </Layout>
  );
}